var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark2 = function SvgQuestionMark2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#717171",
    stroke: "#717171",
    strokeWidth: 3.5,
    d: "M27.999 45.082a1.516 1.516 0 1 1 0 3.033 1.516 1.516 0 0 1 0-3.033Zm0-40.441c5.704 0 11.597 4.502 11.597 10.663 0 5.278-2.881 7.882-5.656 10.341l-.078.069c-1.372 1.218-2.769 2.46-3.783 3.969-1.065 1.585-1.684 3.413-1.684 5.78a.396.396 0 1 1-.793 0c0-4.559 2.188-7.106 4.583-9.31l1.035-.93.116-.102c1.37-1.214 2.766-2.46 3.782-3.984 1.065-1.597 1.685-3.444 1.685-5.833 0-5.615-5.422-9.87-10.804-9.87s-10.804 4.255-10.804 9.87a.396.396 0 1 1-.793 0C16.402 9.143 22.295 4.64 28 4.64Z"
  })));
};
export default SvgQuestionMark2;